import { render, staticRenderFns } from "./DanhGiaDDATDetailList.vue?vue&type=template&id=28a8a6c4&"
import script from "./DanhGiaDDATDetailList.vue?vue&type=script&lang=js&"
export * from "./DanhGiaDDATDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports